const g = [
  c("short-text", "Texte court", "Reponse courte", !1),
  c("long-text", "Texte long", "Reponse longue", !0),
  y(),
  f("single-choice", "Choix unique", "Selectionnez une option", !1),
  f("multiple-choice", "Choix multiple", "Selectionnez une ou plusieurs options", !0),
  f("dropdown", "Liste deroulante", "Selectionnez une option", !1),
  b(),
  h(),
  x(),
  C(),
  L()
];
function c(e, t, i, r) {
  return {
    id: e,
    label: t,
    description: r ? "Champ texte multiligne." : "Champ texte court.",
    defaultTitle: i,
    defaultConfig: {},
    createDefaultQuestion: (n) => ({
      id: n,
      type: "question",
      questionType: e,
      title: i,
      required: !1
    }),
    normalizeConfig: (n) => n,
    validateConfig: (n) => q(n),
    validateAnswer: (n, o) => {
      if (o == null || o === "")
        return n.required ? "Cette question est obligatoire." : null;
      if (typeof o != "string")
        return "La reponse doit etre un texte.";
      const l = a(n.validation, "minLength"), u = a(n.validation, "maxLength");
      return l !== void 0 && o.length < l ? `La reponse doit contenir au moins ${l} caracteres.` : u !== void 0 && o.length > u ? `La reponse doit contenir au maximum ${u} caracteres.` : null;
    },
    serializeAnswer: (n) => typeof n == "string" && n.length > 0 ? n : void 0
  };
}
function y() {
  return {
    id: "yes-no",
    label: "Oui / non",
    description: "Question binaire.",
    defaultTitle: "Votre reponse",
    defaultConfig: {},
    createDefaultQuestion: (e) => ({
      id: e,
      type: "question",
      questionType: "yes-no",
      title: "Votre reponse",
      required: !1
    }),
    normalizeConfig: (e) => e,
    validateConfig: () => [],
    validateAnswer: (e, t) => t == null ? e.required ? "Cette question est obligatoire." : null : typeof t == "boolean" ? null : "La reponse doit etre oui ou non.",
    serializeAnswer: (e) => typeof e == "boolean" ? e : void 0
  };
}
function f(e, t, i, r) {
  return {
    id: e,
    label: t,
    description: r ? "Selection de plusieurs options." : "Selection d'une option.",
    defaultTitle: i,
    defaultConfig: {},
    createDefaultQuestion: (n) => ({
      id: n,
      type: "question",
      questionType: e,
      title: i,
      required: !1,
      options: [
        { value: "Option 1", label: "Option 1" },
        { value: "Option 2", label: "Option 2" }
      ]
    }),
    normalizeConfig: (n) => n,
    validateConfig: (n) => N(n),
    validateAnswer: (n, o) => A(n, o, r),
    serializeAnswer: (n) => r && Array.isArray(n) ? n.filter((o) => typeof o == "string") : typeof n == "string" && n.length > 0 ? n : void 0
  };
}
function b() {
  return {
    id: "number",
    label: "Nombre",
    description: "Champ numerique.",
    defaultTitle: "Nombre",
    defaultConfig: {},
    createDefaultQuestion: (e) => ({
      id: e,
      type: "question",
      questionType: "number",
      title: "Nombre",
      required: !1
    }),
    normalizeConfig: (e) => e,
    validateConfig: (e) => {
      const t = a(e.validation, "min"), i = a(e.validation, "max");
      return t !== void 0 && i !== void 0 && t > i ? [s(e, "QUESTION_INVALID_CONFIG", "La valeur minimale doit etre inferieure a la valeur maximale.")] : [];
    },
    validateAnswer: (e, t) => {
      if (t == null || t === "")
        return e.required ? "Cette question est obligatoire." : null;
      if (typeof t != "number" || Number.isNaN(t))
        return "La reponse doit etre un nombre.";
      const i = a(e.validation, "min"), r = a(e.validation, "max");
      return e.validation.integer === !0 && !Number.isInteger(t) ? "La reponse doit etre un nombre entier." : i !== void 0 && t < i ? `La reponse doit etre superieure ou egale a ${i}.` : r !== void 0 && t > r ? `La reponse doit etre inferieure ou egale a ${r}.` : null;
    },
    serializeAnswer: (e) => typeof e == "number" && !Number.isNaN(e) ? e : void 0
  };
}
function h() {
  return {
    id: "date",
    label: "Date",
    description: "Champ date ISO.",
    defaultTitle: "Date",
    defaultConfig: {},
    createDefaultQuestion: (e) => ({
      id: e,
      type: "question",
      questionType: "date",
      title: "Date",
      required: !1
    }),
    normalizeConfig: (e) => e,
    validateConfig: () => [],
    validateAnswer: (e, t) => t == null || t === "" ? e.required ? "Cette question est obligatoire." : null : typeof t == "string" && /^\d{4}-\d{2}-\d{2}$/.test(t) ? null : "La reponse doit etre une date au format AAAA-MM-JJ.",
    serializeAnswer: (e) => typeof e == "string" && e.length > 0 ? e : void 0
  };
}
function x() {
  return {
    id: "linear-scale",
    label: "Echelle lineaire",
    description: "Note numerique entre deux bornes.",
    defaultTitle: "Votre evaluation",
    defaultConfig: { min: 1, max: 5 },
    createDefaultQuestion: (e) => ({
      id: e,
      type: "question",
      questionType: "linear-scale",
      title: "Votre evaluation",
      required: !1,
      config: { min: 1, max: 5 }
    }),
    normalizeConfig: (e) => ({
      min: a(e, "min") ?? 1,
      max: a(e, "max") ?? 5,
      minLabel: m(e, "minLabel"),
      maxLabel: m(e, "maxLabel")
    }),
    validateConfig: (e) => T(e),
    validateAnswer: (e, t) => p(e, t),
    serializeAnswer: (e) => typeof e == "number" ? e : void 0
  };
}
function C() {
  return {
    id: "rating",
    label: "Note",
    description: "Note de type etoiles.",
    defaultTitle: "Votre note",
    defaultConfig: { max: 5 },
    createDefaultQuestion: (e) => ({
      id: e,
      type: "question",
      questionType: "rating",
      title: "Votre note",
      required: !1,
      config: { max: 5 }
    }),
    normalizeConfig: (e) => ({
      max: a(e, "max") ?? 5
    }),
    validateConfig: (e) => {
      const t = a(e.config, "max") ?? 5;
      return t < 2 || t > 10 ? [s(e, "QUESTION_INVALID_CONFIG", "La note maximale doit etre comprise entre 2 et 10.")] : [];
    },
    validateAnswer: (e, t) => p(e, t, 1),
    serializeAnswer: (e) => typeof e == "number" ? e : void 0
  };
}
function L() {
  return {
    id: "statement",
    label: "Texte informatif",
    description: "Bloc sans reponse attendue.",
    defaultTitle: "Information",
    defaultConfig: {},
    createDefaultQuestion: (e) => ({
      id: e,
      type: "question",
      questionType: "statement",
      title: "Information",
      required: !1
    }),
    normalizeConfig: (e) => e,
    validateConfig: () => [],
    validateAnswer: () => null,
    serializeAnswer: () => {
    }
  };
}
function q(e) {
  const t = a(e.validation, "minLength"), i = a(e.validation, "maxLength");
  return t !== void 0 && i !== void 0 && t > i ? [s(e, "QUESTION_INVALID_CONFIG", "La longueur minimale doit etre inferieure a la longueur maximale.")] : [];
}
function N(e) {
  const t = [], i = /* @__PURE__ */ new Set();
  e.options.length === 0 && t.push(s(e, "QUESTION_INVALID_OPTIONS", "La question doit proposer au moins une option."));
  for (const r of e.options)
    (r.value.trim().length === 0 || r.label.trim().length === 0) && t.push(s(e, "QUESTION_INVALID_OPTIONS", "Les options doivent avoir une valeur et un libelle.")), i.has(r.value) && t.push(s(e, "QUESTION_INVALID_OPTIONS", `L'option "${r.value}" est dupliquee.`)), i.add(r.value);
  return t;
}
function A(e, t, i) {
  if (t == null || t === "" || Array.isArray(t) && t.length === 0)
    return e.required ? "Cette question est obligatoire." : null;
  const r = new Set(e.options.map((n) => n.value));
  return i ? Array.isArray(t) ? t.every((n) => typeof n == "string" && r.has(n)) ? null : "La reponse contient une option inconnue." : "La reponse doit etre une liste d'options." : typeof t == "string" && r.has(t) ? null : "La reponse doit correspondre a une option.";
}
function T(e) {
  const t = a(e.config, "min") ?? 1, i = a(e.config, "max") ?? 5;
  return !Number.isInteger(t) || !Number.isInteger(i) || t >= i ? [s(e, "QUESTION_INVALID_CONFIG", "L'echelle doit definir deux bornes entieres avec min < max.")] : [];
}
function p(e, t, i) {
  if (t == null)
    return e.required ? "Cette question est obligatoire." : null;
  if (typeof t != "number")
    return "La reponse doit etre un nombre.";
  const r = a(e.config, "min") ?? i ?? 1, n = a(e.config, "max") ?? 5;
  return t >= r && t <= n ? null : `La reponse doit etre comprise entre ${r} et ${n}.`;
}
function s(e, t, i) {
  return {
    code: t,
    severity: "error",
    message: i,
    elementId: e.id,
    path: ["pages", e.id]
  };
}
function a(e, t) {
  const i = e[t];
  return typeof i == "number" && Number.isFinite(i) ? i : void 0;
}
function m(e, t) {
  const i = e[t];
  return typeof i == "string" ? i : void 0;
}
function w(e) {
  return Array.isArray(e) ? e.map((t, i) => {
    if (typeof t == "string") {
      const o = t.trim();
      return o.length > 0 ? { value: o, label: o } : null;
    }
    if (!v(t))
      return null;
    const r = typeof t.value == "string" ? t.value : `option_${i + 1}`, n = typeof t.label == "string" ? t.label : r;
    return { value: r, label: n };
  }).filter((t) => t !== null) : [];
}
function v(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const I = [
  {
    id: "qastia-light",
    label: "Qastia clair",
    tokens: {
      "--qf-accent": "#2f6f73",
      "--qf-accent-contrast": "#ffffff",
      "--qf-surface": "#ffffff",
      "--qf-surface-muted": "#f4f7f6",
      "--qf-border": "#d9e2df",
      "--qf-text": "#1f2933",
      "--qf-text-muted": "#66737a"
    }
  },
  {
    id: "coaching",
    label: "Coaching",
    tokens: {
      "--qf-accent": "#315f8c",
      "--qf-accent-contrast": "#ffffff",
      "--qf-surface": "#ffffff",
      "--qf-surface-muted": "#eef4f8",
      "--qf-border": "#cfdae3",
      "--qf-text": "#172433",
      "--qf-text-muted": "#637184"
    }
  }
], O = [];
function Q(e = {}) {
  const t = e.collisionStrategy ?? "error", i = d("question type", g, e.questionTypes, t), r = d("theme", I, e.themes, t), n = d("validator", O, e.validators, t);
  return {
    questionTypes: i,
    themes: r,
    validators: n
  };
}
function d(e, t, i, r) {
  const n = /* @__PURE__ */ new Map();
  for (const o of t)
    n.set(o.id, o);
  for (const o of i ?? []) {
    if (n.has(o.id) && r === "error")
      throw new Error(`Duplicate ${e} id: ${o.id}`);
    n.has(o.id) && r === "keep-first" || n.set(o.id, o);
  }
  return n;
}
const S = Q();
export {
  I as a,
  O as b,
  Q as c,
  S as d,
  w as n
};
